<p>client-detail-view works!</p>
